"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var THOUSAND_SEPERATOR_REGEXP = /(\d+)(\d{3})/;
/**
 * Handles formatting of prices.
 */

var PriceFormatter = /*#__PURE__*/function () {
  function PriceFormatter() {
    _classCallCheck(this, PriceFormatter);
  }

  _createClass(PriceFormatter, null, [{
    key: "format",

    /**
     * Formats a price.
     *
     * @param {number} amount Price amount.
     * @param {object} config Configuration to use. Usually recieved from common translations under the "prices" property.
     * @param {number} config.currencyCode Currency code used.
     * @param {number} config.numberOfDecimals Number of decimals.
     * @param {boolean} config.thousandSeparatorEnabled TRUE to enable thousand separator.
     * @param {string} config.thousandSeparator Thousand separator.
     * @param {boolean} config.replaceNoValueDecimals TRUE to replace no value decimals.
     * @param {string} config.noValueDecimalsString No value decimals string.
     * @param {string} config.decimalSeparator Decimal separator.
     * @param {number} config.numberOfDecimals Number of decimals.
     * @param {string} config.symbolSpacing Symbol spacing.
     * @param {string} config.currencySymbol Currency symbol.
     * @param {string} config.currencyPosition Currency position ("before" or "after").
     * @param {boolean} [useHtml] TRUE to use HTML. This will add a span with dir="ltr", so that '1 400' wont get reversed in morocco. Default is TRUE.
     * @returns {string} Formatted price with currency.
     */
    value: function format(amount, config) {
      var useHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (typeof amount !== 'number' || isNaN(amount)) {
        return '';
      }

      config.numberOfDecimals = parseInt(config.numberOfDecimals);

      if (isNaN(config.numberOfDecimals)) {
        config.numberOfDecimals = 2;
      }

      config.thousandSeparator = config.thousandSeparator || ' ';

      if (config.noValueDecimalsString === ' ') {
        config.noValueDecimalsString = '';
      }

      var priceString, integer; // Since the number of trailing zeroes is set with the toFixed,
      // The values cannot be integers

      amount = amount.toFixed(config.numberOfDecimals).split('.');
      integer = amount[0];
      var fraction = amount.length === 2 ? amount[1] : 0;

      if (config.currencyCode === 'INR') {
        var result = [];
        var thousand = '';

        if (integer.length > 3) {
          thousand = ',' + integer.substr(integer.length - 3);
          integer = integer.substr(0, integer.length - 3);

          while (integer.length > 2) {
            result.unshift(integer.substr(integer.length - 2));
            integer = integer.substr(0, integer.length - 2);
          }
        }

        if (integer.length > 0) {
          result.unshift(integer);
        }

        integer = result.join(',') + thousand;
      } else if (config.thousandSeparatorEnabled && integer.length > 3) {
        while (THOUSAND_SEPERATOR_REGEXP.test(integer)) {
          integer = integer.replace(THOUSAND_SEPERATOR_REGEXP, '$1' + config.thousandSeparator + '$2');
        }
      }

      if (config.replaceNoValueDecimals && typeof config.noValueDecimalsString === 'string' && Number(fraction) === 0) {
        priceString = integer + config.noValueDecimalsString;
      } else if (config.decimalSeparator && config.numberOfDecimals !== 0) {
        priceString = integer + config.decimalSeparator + fraction;
      } else {
        priceString = integer;
      } // Add ltr so that '1 400' wont get reversed in morocco


      if (useHtml) {
        priceString = '<span class="IKEA__price-amount" dir="ltr">' + priceString + '</span>';
      }

      var priceWithCurrency = [priceString, config.symbolSpacing ? ' ' : '', config.currencySymbol];

      if (config.currencyPosition === 'before') {
        priceWithCurrency.reverse();
      }

      return useHtml ? '<span class="IKEA__price"><span class="IKEA__price-value">' + priceWithCurrency.join('') + '</span></span>' : priceWithCurrency.join('');
    }
    /**
     * Formats a price to be used for a single article.
     *
     * @param {number} amount Price amount.
     * @param {object} config Configuration to use. Usually recieved from common translations under the "prices" property.
     * @param {number} config.currencyCode Currency code used.
     * @param {number} config.numberOfDecimals Number of decimals.
     * @param {boolean} config.thousandSeparatorEnabled TRUE to enable thousand separator.
     * @param {string} config.thousandSeparator Thousand separator.
     * @param {boolean} config.replaceNoValueDecimals TRUE to replace no value decimals.
     * @param {string} config.noValueDecimalsString No value decimals string.
     * @param {string} config.decimalSeparator Decimal separator.
     * @param {number} config.numberOfDecimals Number of decimals.
     * @param {string} config.symbolSpacing Symbol spacing.
     * @param {string} config.currencySymbol Currency symbol.
     * @param {string} config.currencyPosition Currency position ("before" or "after").
     * @param {object} article An article object returned from ArticleServiceFacade when formatting is done on a single item. Additional information like package information will be added.
     * @param {boolean} [useHtml] TRUE to use HTML. This will add a span with dir="ltr", so that '1 400' wont get reversed in morocco. Default is TRUE.
     * @returns {string} Formatted price with currency.
     */

  }, {
    key: "formatForArticle",
    value: function formatForArticle(amount, config, article) {
      var useHtml = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var priceWithCurrency = this.format(amount, config, useHtml);
      var priceUnitFactor = parseFloat(article.PriceUnitFactor);

      if (priceWithCurrency === '') {
        return '';
      }

      if (!isNaN(priceUnitFactor) && typeof article.PriceUnitText === 'string' && (priceUnitFactor > 1 || article.PriceUnitTextEn && article.PriceUnitTextEn !== 'pack')) {
        if (useHtml) {
          return priceWithCurrency.slice(0, -7) + '<span class="IKEA__price-slash">/</span><sub class="IKEA__price-sub">' + article.PriceUnitFactor + ' ' + article.PriceUnitText + '</sub></span>';
        }

        return priceWithCurrency + '/' + article.PriceUnitFactor + ' ' + article.PriceUnitText;
      }

      return priceWithCurrency;
    }
  }]);

  return PriceFormatter;
}();

exports.default = PriceFormatter;